import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from 'projects/chat-common/src/lib/services/auth.service';

const TOKEN_KEY = AuthService.BELLABEAT_ACCESS_TOKEN;

export const openAiInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq);
};
